// src/features/adm/entities/account/ui/AccountOptionsRisks/RiskScaleSection.tsx
import { RiskScaleItem } from "@/features/risks/entities/risk/model/risk.types"
import ListItem from "@/components/list-item"
import ListInput from "@/components/list-input"
import Range from "@/components/range"
import Chip from "@/components/chip"
import ListButton from "@/components/list-button"
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { t } from "i18next"
import { EditableScaleKey } from "../../../../risks/entities/risk/ui/RiskOrganizationScalesConfig"

type Props = {
  title: string
  scaleKey: EditableScaleKey
  items: RiskScaleItem[]

  onEditValue: (scaleKey: EditableScaleKey, index: number, value: number) => void
  onEditLabel: (scaleKey: EditableScaleKey, index: number, label: string) => void
  onAddItem: (scaleKey: EditableScaleKey, index: number) => void
  onRemoveItem: (scaleKey: EditableScaleKey, index: number) => void
}

export default function RiskScaleSection({
  title,
  scaleKey,
  items,
  onEditValue,
  onEditLabel,
  onAddItem,
  onRemoveItem
}: Props) {
  return (
    <ListItem isSmall>
      <div className="flex-col w-full">
        <h3 className="font-bold mb-4">{title}</h3>

        {items.map((item, i) => (
          <div key={i} className="grid grid-cols-[1fr,2fr,auto,.2fr] items-center gap-3 mb-2">
            <ListInput value={item.label ?? ""} onEditEnd={(newLabel: string) => onEditLabel(scaleKey, i, newLabel)} />

            <Range
              min={1}
              max={20}
              step={1}
              value={item.value}
              isFullWidth
              hideValue
              onChange={(val: number) => onEditValue(scaleKey, i, val)}
            />

            <Chip>{item.value}</Chip>

            <div className="flex gap-2 justify-end ml-4">
              <ListButton
                icon={faTrash}
                text={`${t("utils_delete")} ${title.toLowerCase()}`}
                onClick={() => onRemoveItem(scaleKey, i)}
              />
              <ListButton
                icon={faPlus}
                text={`${t("utils_add")} ${title.toLowerCase()}`}
                onClick={() => onAddItem(scaleKey, i)}
              />
            </div>
          </div>
        ))}
      </div>
    </ListItem>
  )
}
